<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" @goMore="goMore" :showMore="list.length > 0"/>
            <ul class="studio" v-if="list.length" v-loading="loading">
                <li class="studio-item" v-for="(item, index) in list" :key="item.id" @click="toDetail(item.id)">
                    <div class="list-item link" v-link="linkUrl(item.id)">
                        <div class="list-item-img">
                            <LazyImage :src="item.logo" className="img" />
                        </div>
                        <div class="list-item-content">
                            <div class="title">
                                <Ellipsis :content="item.shopName" width="240px" :lineHeight="20"></Ellipsis>
                            </div>
                            <p class="semester-stage text-overflow">
                                <i :class="['ss-icon', 'ss-icon-' + index%3]"></i>
                                <Ellipsis :content="`学段学科：${item.stageSubjectName}`" width="224px" :lineHeight="20"></Ellipsis>
                                <!-- 学段学科：{{}} -->
                            </p>
                            <div class="studio-info">
                                <div>成员数：<span class="num">{{formatNum(item.memberCount || 0)}}</span></div>
                                <span class="sep">|</span>
                                <div>活动数：<span class="num">{{formatNum(item.activityNum || 0)}}</span></div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData v-else class="no-data" url="no-lesson.png" info="暂无数据~" />
        </div>
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/index.vue'
import BigNoData from '@/components/no-data.vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { ref, onMounted } from 'vue';
import { pageJump } from '@/global/location-transfer'
import { jumpHref } from '@/router/jumpHref.js';
import { handleStageSubject } from '@/lib/tools';
import Ellipsis from '@/components/ellipsis.vue';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    }
});

const list = ref([]);

const loading = ref(false);
let filterData = ref({
    pageIndex: 1,
    pageSize: 6,
    topSort: 1
});

function formatNum(num) {
    if(Number(num) > 9999) {
        return '9999+';
    }
    return num;
}

function getList() {
    loading.value = true
    G_transmit('getStudioList', {
        data: {
            ...filterData.value
        },
        message: false
    }).then(({ data, status: { code, message } }) => {
        if(code === 200){
            let arr = data && data.rows || [];
            list.value = arr.length && arr.map(item => {
                item.stageSubjectName = handleStageSubject(JSON.parse(item.stageSubjectJson), '暂无');
                return item;
            }) || [];
        }
        loading.value = false;
    }).catch(err => {
        console.log('error', err)
        loading.value = false;
    });
}

// 跳转慕课详情
function toDetail(id) {
    pageJump(jumpHref.studio.studioDetail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.studio.studioDetail(id),
        className: 'link-item'
    }
}

function goMore() {
    pageJump(jumpHref.studio.square);
}

onMounted(() => {
     getList();
});
</script>

<style lang="scss" scoped>
.ss-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 2px;
}
@each $index in 0, 1, 2{
    .ss-icon-#{$index} {
        background: url('~@/assets/img/home/shop#{$index}@2x.png') no-repeat;
        background-size: 16px 16px;
    }        
}
.common-module-page {
    // width: 100vw;
    background: #FFFFFF;
    // padding-bottom: 40px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
    .list-item {
        display: flex;
        color: #000;
    }
    .list-item-img {
        width: 100px;
        height: 100px;
        margin-right: 14px;
    }
    .studio {
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;
    }
    .studio-item {
        display: flex;
        margin-right: 24px;
        margin-top: 24px;
        width: 384px;
        height: 132px;
        padding: 16px;
        border-radius: 4px;
        border: 1px solid #E0E2E4;
        &:nth-child(3n) {
            margin-right: 0;
        }
        &:hover {
            .title {
                color: var(--home-main-color);
            }
        }
    }
    .title {
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        line-height: 1;
    }
    .semester-stage {
        display: flex;
        align-items: center;
        margin-top: 12px;
    }
    .studio-info {
        font-size: 14px;
        color: #999;
        margin-top: 14px;
        display: flex;
        .sep {
            margin: 0 15px;
            color: #666;
        }
        .num {
            color: #666;
        }
    }
}
</style>